export default __webpack_public_path__ + "static/do-stack-images-0fe09f610cde6abfaf1b49a4d882552f.png";